import {getBestSelling, getBranches} from './thunk';

export const builderBranches = (builder: any) => {
  builder.addCase(getBranches.pending, (state: any) => {
    state.loadingBranches = true;
    state.getBranchesError = '';
    state.getBranchesSuccess = false;
  });
  builder.addCase(getBranches.rejected, (state: any) => {
    state.loadingBranches = false;
    state.getBranchesError = 'از سمت ما مشکلی پیش آمده، لطفا دوباره تلاش کنید';
    state.getBranchesSuccess = false;
  });
  builder.addCase(getBranches.fulfilled, (state: any, action: any) => {
    state.getBranchesError = '';
    state.loadingBranches = false;
    state.getBranchesSuccess = true;
    const {branches, profile, profileId, pagination} = action.payload;
    state.branches = state.getBranchesPage === 0 ? branches : [...state.branches, ...branches];
    state.profile = profile;
    state.profileId = profileId;
    const vendor = state.selectedVendor || branches[0];
    if (vendor) {
      state.selectedVendor = vendor;
      localStorage.setItem('selectedVendor', JSON.stringify(vendor));
    }
    state.branchesPagination = pagination;
  });
};

export const builderGetBestSelling = (builder: any) => {
  builder.addCase(getBestSelling.rejected, (state: any) => {
    state.loadingBestSelling = true;
    state.BestSellingError = 'از سمت ما مشکلی پیش آمده، لطفا دوباره تلاش کنید ';
  });
  builder.addCase(getBestSelling.pending, (state: any) => {
    state.BestSellingError = '';
    state.loadingBestSelling = true;
  });
  builder.addCase(getBestSelling.fulfilled, (state: any, action: any) => {
    state.BestSellingError = '';
    state.loadingBestSelling = false;
    state.BestSellingData = action.payload;
  });
};
